import Link from 'next/link';
import Typography from 'components/Typography';
import classes from 'styles/components/Anniversary/AnniversaryBarBottom.module.scss';

const AnniversaryBarBottom = () => (
  <div className={classes.graphicsBox}>
    <div className={classes.boxLeft}>
      <div className={classes.leftContent}>
        <Typography>
          Celebrating 25 years
          <br />
          <b>as part of MetLife</b>
        </Typography>
        <Link href="/25th-anniversary">
          <a className={classes.button}>
            <Typography>View the journey</Typography>
          </a>
        </Link>
      </div>
    </div>
    <div className={classes.mainImageContainer}>
      <div className={classes.mainImage} />
    </div>
  </div>
);

export default AnniversaryBarBottom;
